export default {
  de: {
    titles: {
      start_page: 'Startseite',
      login: 'Einloggen',
      register: 'Registrieren',
      profile: 'Profil',
      logout: 'Ausloggen',
      impressum: 'Impressum',
      purchase: 'Kaufen',
      forgot_password: 'Passwort vergessen',
      reset: 'Passwort zurücksetzen',
      email_verification: 'E-Mail-Verifizierung',
      order_type: 'Bestellung',
      purchase_type: 'Einkauf',
      my_orders: 'Meine Einkäufe',
      navbar_purchase: 'Jetzt freies Gericht kaufen',
      home: 'Herzlich willkommen bei mein-potpourri.de! Hier können Sie Ihre ' +
      'Bestellungen verwalten, spontane Einkäufe verbuchen und Potpourri' +
      ' mit uns gemeinsam gestalten.',
      posts_by: 'Küchenpost by',
      edit_purchase: 'Einkauf bearbeiten',
      edit_order: 'Bestellung bearbeiten',
      total: 'Gesamt',
      update_password: 'Ändere das Passwort',
      update_profile: 'Profil aktualisieren',
      update_email: 'E-Mail aktualisieren',
      suggestions: 'Stimmen Sie für nächste Woche ab',
      suggestions_sub: 'Mehrfachauswahl ist möglich',
      ingredients: 'Zutaten',
      report_a_problem: 'Problem melden',
      datenschutz: 'Datenschutz',
      lottery: 'Nehmen Sie an der Potpourri-Frucht-Tombola teil!',
      lottery_sub: 'Den Gewinncode finden Sie in der Bestätigungsmail zu Ihrer letzten Bestellung.',
      lottery_won: 'Sie haben gewonnen!',
      promocodes: 'Gewinncodes',
      nutritions: 'Ernährungswerte je Portion',
      resend_verification: 'Bestätigungs-Email erneut senden',
      rating: 'Wie gut hat es Ihnen beim letzen Mal gefallen?',
      ratings: 'Bewertungen',
      invoices: 'Rechnungen',
      sepa: 'SEPA-Mandat',
      sepa_full: 'SEPA-BASIS-LASTSCHRIFTMANDAT',
      tour_plans: 'Meine Tour',
      delivery_areas: 'Liefergebiete',
      tour_plan: 'Tourenplanung',
      cooking_support: 'Zubereiten',
      select_a_dish: 'Gericht auswählen',
      overview_preparation: 'Übersicht Zubereitung {name}',
      employee_data: 'Mitarbeiterdaten',
      work_times: 'Arbeitszeiten',
      work_time: 'Arbeitszeit',
      create_work_time: 'Neue Arbeitszeit',
      edit_work_time: 'Arbeitszeit bearbeiten',
      check_in_date_time: 'Check-In',
      check_out_date_time: 'Check-Out',
      trip_report: 'Fahrbericht',
      trip_reports: 'Fahrberichte',
      create_trip_report: 'Neuer Fahrbericht',
      edit_trip_report: 'Fahrbericht bearbeiten',
      update_address: 'Adresse aktualisieren',
      net_score: 'Wie wahrscheinlich ist es, dass Du Potpourri Freund:innen und Kolleg:innen weiterempfehlen würdest?',
      my_account: 'Mein Konto',
      notification_settings: 'Newsletter',
    },
    fields: {
      name: 'Name',
      first_name: 'Vorname',
      last_name: 'Nachname',
      email: 'Email',
      password: 'Passwort',
      password_confirmation: 'Passwort Bestätigung',
      repeat_password: 'Passwort wiederholen',
      current_password: 'Aktuelles Passwort',
      new_password: 'Neues Kennwort',
      new_password_repeat: 'Bestätige neues Passwort',
      firm_name: 'Firmenname',
      gender: 'Geschlecht',
      quantity: 'Anzahl',
      as_guest: 'Als Gast',
      create_account: 'Ein Konto erstellen',
      subject: 'Gegenstand',
      description: 'Beschreibung',
      or: 'ODER',
      comment: 'Kommentar',
      admin_comment: 'Potpourri Kommentar',
      discount: 'Rabatt',
      promocode: 'Gewinncode',
      energy: 'Energie',
      fat: 'Fett',
      fatty_acids: 'Davon gesättigte Fettsäuren',
      carbon_hydrates: 'Kohlenhydrate',
      sugar: 'Davon Zucker',
      protein: 'Eiweiß',
      salt: 'Salz',
      fiber: 'Ballaststoffe',
      comments_and_tips: 'Kommentare und Tipps',
      iban: 'IBAN',
      name_of_account: 'Name des Kontoinhabers',
      produced_amount: 'Anzahl fertig',
      not_produced_amount: 'Anzahl nicht fertig',
      next_preparation_number: 'Anzahl nächste Zubereitung',
      sex: {
        1: 'Herr',
        2: 'Frau',
      },
      tour_name: 'Tourname',
      dob: 'Geburtstag',
      address: 'Adresse',
      mobile_number: 'Handynummer',
      hourly_rate: 'Stundenlohn (brutto)',
      mileage_allowance: 'Kilometerpauschale',
      employment_type: 'Beschäftigungstyp',
      check_in_date_time: 'Check-In',
      check_out_date_time: 'Check-Out',
      paid: 'Bezahlt',
      date: 'Datum',
      start_location: 'Startpunkt',
      end_location: 'Endpunkt',
      distance: 'Entfernung',
      destination: 'Ziel(e)',
      delivery_areas: 'Liefergebiete',
      remarks: 'Bermerkungen',
      delivery_type: 'Lieferart',
      postal_code: 'Postleitzahl',
      street: 'Straße',
      town: 'Stadt',
      notes: 'Hinweise',
      potpourri_notes: 'Sonstige Hinweise für das Potpourri-Team',
      phone_number: 'Telefonnummer',
      driver_notes: 'Hinweise für den Fahrer',
      house_number: 'Hausnummer',
      driven_km: 'Gefahrene Km',
    },
    table_labels: {
      id: '#',
      description: 'Beschreibung',
      quantity: 'Anzahl',
      total_price: 'Gesamtpreis',
      price: 'Preis',
      details: 'Einzelheiten',
      name: 'Name',
      updated_at: 'Zuletzt geändert',
      type: 'Art',
      total: 'Gesamt',
      actions: 'Aktionen',
      status: 'Status',
      expiration_date: 'Verfallsdatum',
      issue_date: 'Ausstellungsdatum',
      code: 'Gewinncode',
      start_date: 'Anfangsdatum',
      end_date: 'Endtermin',
      ordered_at: 'Bestellt bei',
      rating: 'Bewertung',
      created_at: 'Erstellt am',
      check_in_date_time: 'Check-In',
      check_out_date_time: 'Check-Out',
      check_out_time: 'Check-Out',
      paid: 'Bezahlt',
      date: 'Datum',
      distance: 'Entfernung',
      delivery_type: 'Lieferart',
      service_name: 'Dienstname',
    },
    placeholders: {
      name: 'Name eingeben',
      first_name: 'Vorname eingeben',
      last_name: 'Nachname eingeben',
      email: 'Email eingeben',
      firm_name: 'Suchen Sie den Firmennamen',
      password: 'Passwort eingeben',
      password_confirmation: 'Passwort Bestätigung eingeben',
      current_password: 'Aktuelles Passwort eingeben',
      new_password_repeat: 'Passwortbestätigung eingeben',
      subject: 'Gegenstand eingeben',
      description: 'Beschreibung eingeben',
      comment: 'Kommentar eingeben',
      discount: 'Rabatt eingeben',
      promocode: 'Z.B. 1XB3RK',
      iban: 'IBAN eingeben',
      name_of_account: 'Name des Kontoinhabers eingeben',
      produced_amount: 'Anzahl fertig',
      not_produced_amount: 'Anzahl nicht fertig',
      next_preparation_number: 'Anzahl nächste Zubereitung',
      dob: 'Geburtstag eingeben',
      address: 'Adresse eingeben',
      mobile_number: 'Handynummer eingeben',
      hourly_rate: 'Stundenlohn (brutto) eingeben',
      mileage_allowance: 'Kilometerpauschale eingeben',
      employment_type: 'Beschäftigungstyp eingeben',
      check_in_date_time: 'Check-In eingeben',
      check_out_date_time: 'Check-Out eingeben',
      paid: 'Bezahlt eingeben',
      date: 'Datum',
      start_location: 'Start punkt',
      end_location: 'End punkt',
      distance: 'Entfernung',
      destination: 'Ziel(e)',
      delivery_areas: 'Liefergebiete',
      remarks: 'Bermerkungen',
      postal_code: 'Postleitzahl eingeben',
      street: 'Straße und Hausnummer eingeben',
      town: 'Stadt eingeben',
      notes: 'Hinweise eingeben',
      potpourri_notes: 'Sonstige Hinweise für das Potpourri-Team eingeben',
      phone_number: 'Telefonnummer eingeben',
      driver_notes: 'Hinweise für den Fahrer eingeben',
      house_number: 'Hausnummer eingeben',
    },
    actions: {
      continue: 'Weiter',
      forgot_password: 'Passwort vergessen?',
      register_now: 'Jetzt neu registrieren',
      send_forgot_password: 'Neues Passwort anfordern',
      submit: 'Speichern',
      view_order: 'Bestellung ansehen',
      view_purchase: 'Kauf ansehen',
      ok: 'OK',
      stop: 'Abbrechen',
      purchase: 'Kaufen',
      load_more_posts: 'Weitere Posts zeigen',
      pre_order_now: 'Jetzt bestellen',
      login_price: 'Anmelden <br /> für Preisinfo',
      login_price_no_wrap: 'Anmelden für Preisinfo',
      skip_vote: 'Abstimmung überspringen',
      submit_order: 'Bestellung speichern',
      accept_cookie: 'Cookies akzeptieren',
      post_subscribe: 'Küchenpost erhalten',
      post_subscribe_cancel: 'Ohne Küchenpost leben',
      email_subscribe: 'Erinnerungsmail erhalten',
      email_subscribe_cancel: 'Ohne Erinnerungsmail leben',
      lottery_submit: 'Los geht\'s',
      skip_lottery: 'Tombola überspringen',
      accept_prize: 'Gewinn annehmen',
      donate: 'Ich schenk\'s dem Potpourri-Team',
      resend_verification: 'Bestätigungs-Email erneut senden',
      rating_submit: 'Senden',
      skip_rating: 'Bewertung überspringen',
      start_tour: 'Tour starten',
      delivered: 'Geliefert',
      post_subscription_activated: 'Küchenpost aktiviert',
      post_subscription_deactivated: 'Küchenpost deaktiviert',
      email_subscription_activated: 'Erinnerungsmail',
      email_subscription_deactivated: 'Erinnerungsmail',
      change_address: 'Adresse ändern',
      discard_changing_address: 'Änderungsadresse verwerfen',
      skip: 'Überspringen',
      cancel: 'Abbrechen',
    },
    messages: {
      default_error: 'Es ist ein Fehler aufgetreten. Versuchen Sie es erneut oder wenden Sie sich an den Administrator',
      update_email: 'Wenn Sie Ihre neue Emailadresse speichern, werden wir Sie jetzt abmelden und Ihnen eine Bestätigungsemail an die neue Adresse senden. Sobald Sie diese Email bestätigt haben, können Sie sich mit der neuen Email und dem alten Passwort wieder einloggen."',
      forgot_password_sent: 'Der Wiederherstellungslink wurde an Ihre E-Mail-Adresse gesendet',
      password_changed: 'Das Passwort wurde zurückgesetzt. Sie können sich jetzt einloggen.',
      empty_firm_list: 'Es gibt keine Firma mit einem solchen Namen',
      order_verify_email: 'Bestätige Deine Emailadresse und melde dich an, um Deine Bestellung zu sehen und zu bearbeiten',
      purchase_verify_email: 'Überprüfen Sie die E-Mail und melden Sie sich an, um Ihre Einkäufe anzuzeigen',
      purchase_note: 'Wenn Du ein registrierter Kunde bist kannst Du Deinen Kauf 24 Stunden lang ändern bzw. stornieren.',
      company_info: {
        message: 'Es können nur registrierte Firmen ausgewählt werden. ' +
        'Bitte geben Sie drei Buchstaben Ihres Firmennamens ein und klicken Sie dann auf einen der Vorschläge. ' +
        'Sollte Ihre Firma nicht erscheinen, melden Sie sich bitte unter {0}.',
        email: 'info@mittagsgutessen.de',
      },
      no_posts: 'Im Moment gibt es keine Küchenpfosten',
      no_invoices: 'Es gibt keine Rechnungen',
      thanks_for_purchase: 'Vielen Dank für Deinen Einkauf',
      thanks_for_order: 'Vielen Dank für Deine Bestellung',
      order_type: {
        active: 'Aktiv',
        cancelled: 'Abgeschlossen',
        deleted: 'Gelöscht',
      },
      promocode_status: {
        active: 'aktiv',
        expired: 'verfallen',
        used: 'wird eingesetzt',
      },
      out_of_order: 'Ausverkauft',
      no_orders: 'Sie haben noch keine Bestellungen',
      no_promocodes: 'Sie haben noch keine Gewinncodes',
      above_total_text: 'Alle Preise enthalten 7% gesetzliche MwSt..',
      issue_submitted: 'Vielen Dank, dass Sie die Ausgabe eingereicht haben',
      no_active_forms: 'Momentan sind keine aktiven Bestellformulare vorhanden.',
      after_total: 'inkl. 7% gesetzlicher MwSt.',
      cookie: 'Wir verwenden Cookies, um dir den bestmöglichen Service zu gewährleisten. Weitere Informationen finden Sie in unseren Datenschutzrichtlinien unter ',
      post_subscribe: 'Freitags versenden wir unsere Küchenpost. Nur damit können Sie Gerichte vorbestellen. Außerdem geben wir uns viel Mühe darin wertvollen Inhalt und keine stumpfe Werbung zu liefern. Natürlich kann man sich jederzeit von der Küchenpost abmelden.',
      promocode: 'Gewinncodes sind 10 Tage gültig.',
      // donate: '*Wenn Ihr Euren Gewinn nicht annehmen möchtet, dann spenden wir Ihn an die Dortmunder Tafel. \n' +
      // 'Einmal im Monat informieren wir Euch in der Küchenpost über den Umfang der gespendeten Tombola-Gewinne.',
      verification_resent: 'Bestätigungs-E-Mail wurde an Deine E-Mail gesendet.',
      low_star: '1 Stern = das war nix!',
      high_star: '5 Sterne = das war richtig gut!',
      no_ratings: 'Nichts zu zeigen',
      sepa_accepted: 'Sie haben die Allgemeinen Geschäftsbedingungen von SEPA-LASTSCHRIFTMANDAT akzeptiert',
      postal_code_format: 'Die Postleitzahl, die sie eingegeben haben, ist nicht Teil unseres Liefergebietes. Schreiben Sie uns gerne eine Email an info@mittagsgutessen.de, damit wir prüfen können, ob wir für Sie eine Ausnahme machen können ;-)',
      delivery_price: 'Bei einem Bestellwert unter {deliveryPriceLimit} EUR berechnen wir bei Lieferungen nach Hause {deliveryPrice} EUR Liefergebühr.',
      pickup_address: 'Wenn Ihr Abholung wählt, könnt Ihr Eure Gerichte am Dienstag- und Mittwochvormittag zwischen 7:30h und 12h bei uns in der Schleefstraße 1, 44287 Dortmund abholen. Fahrt bitte in die Hofeinfahrt.',
    },
    errors: {
      terms: 'Sie müssen die Datenschutzrichtlinien akzeptieren, um die Registrierung fortzusetzen.',
      article_quantity: 'Nur noch wenige Gerichte verfügbar. Anzahl muss {number} oder weniger sein.',
      sepa_accepted: 'Sie müssen die Bedingungen des SEPA-LASTSCHRIFTMANDAT akzeptieren',
      same_company: 'Sie können nicht für Bilder aus Ihrem eigenen Team abstimmen ;-)',
      klg_num_articles_error: 'Beim kostenlosen Kennenlernen können Sie zwei Gerichte bestellen (ein Mittagsgericht und ein Frühstück oder Smoothie)',
      klg_article_error: 'Ein ausgewähltes Gericht ist leider ausverkauft. Bitte passe Deine Auswahl nochmal an.',
    },
    alerts: {
      delete_entity: 'Möchten Sie dieses {entity} wirklich löschen?',
      delivered_tour_plan: 'Möchten Sie den Artikel wirklich als geliefert markieren?',
    },
    tooltips: {
      dob_select: 'Sie können Pfeile verwenden oder Sie können eingeben, um das Jahr auszuwählen.',
    },
    tos: 'Datenschutzrichtlinien',
    post_subscription: 'Küchenpost erhalten',
    post_subscription_description: 'Ohne Küchenpost ist unser Angebot nur eingeschränkt nutzbar.',
    email_subscription: 'Erinnerungsmail',
    email_subscription_description: 'Damit erinnern wir dich am Montag, falls du vergessen hast zu bestellen.',
    term: 'Ich akzeptiere die {0} von Potpourri',
    copyright: '© 2022 Potpourri',
    name: 'Potpourri',
  },
};



// WEBPACK FOOTER //
// ./src/lang/de.js